import jwt_decode from "jwt-decode";
import {deleteCookie, getCookie} from "./cookie";

const userExpired = new Event('user-expired')

const initLoggedStatus = () => {
  const token = getCookie('tk')
  if (token) {
    const tokenData = jwt_decode(token)
    if (tokenData.exp * 1000 > Date.now()) {
      return true
    }
    deleteCookie('tk')
    window.dispatchEvent(userExpired)
  }
  return false
}

export default initLoggedStatus;
